// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"88":"login-page","316":"register-page","489":"rcontacts-page"}[chunkId] + "." + {"88":"84252d0d","316":"ad66301c","489":"73e29c86"}[chunkId] + ".chunk.js";
};